// Used in tiles.component.html and assignment-info-dialog.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";
// Services/Types/Helpers
import { assetTypeIds } from "@carnegie-learning/cure-types";
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";

@Component({
    selector: "status-launch-buttons",
    templateUrl: "./status-launch-buttons.component.html",
    styleUrls: ["./status-launch-buttons.component.scss"],
    standalone: false
})
export class StatusLaunchButtonsComponent implements OnInit {
    readonly assetTypeIds = assetTypeIds;
    @Input() assignment: Assignment | CompositeTaskAssignment;

    constructor() {}

    ngOnInit(): void {}

    getAssignmentLaunchButtonClass(tile: Assignment | CompositeTaskAssignment) {
        if (tile) {
            if (
                tile?.status === "pending" &&
                tile?.dueStatus !== "overdue" &&
                !this.checkIfInProgress(tile)
            ) {
                return "pending";
            } else if (tile?.dueStatus === "overdue" && !tile?.evaluatedAt) {
                return "overdue";
            } else if (
                this.checkIfInProgress(tile) &&
                tile?.dueStatus !== "overdue" &&
                !tile?.evaluatedAt
            ) {
                return "in-progress";
            } else if (tile?.completedAt || tile?.evaluatedAt) {
                return "review";
            }
        }
    }

    // Check if In Progress
    // A Bundle is In Progress if any of the activities is in the In Progress status
    checkIfInProgress(tile: Assignment | CompositeTaskAssignment) {
        if (tile && tile.asset) {
            const sat = tile.asset.assetTypeId;
            if (sat === assetTypeIds.BUNDLE) {
                // If at least 1 activity has been started and there are still un-submitted activities, show the In Progress flag
                const startedAtFound = (<Assignment>(
                    tile
                )).compositeTaskAssignments.some(
                    (activity) => activity.startedAt
                );

                const notSubmittedFound = (<Assignment>(
                    tile
                )).compositeTaskAssignments.some(
                    (activity) => !activity.completedAt
                );

                if (startedAtFound && notSubmittedFound) {
                    return true;
                }
            } else if (tile.startedAt && !tile.completedAt) {
                return true;
            }
        }
    }
}
